export default "__VITE_ASSET__e8f3213f__"